module.exports = __webpack_public_path__ + "media/pricing/Secure_Storage-8d53df51.svg";